import React from 'react'
import PropTypes from 'prop-types'

import VideoPlayer from 'components/atoms/VideoPlayer'
import { getImageURL } from 'utils/image'

import * as S from './styled'

const Illustration = ({ illustration, ...rest }) => {
  if (!illustration) {
    return <></>
  }

  const { url, mime } = illustration

  return (
    <S.Container {...rest} key={url}>
      {mime.includes('video') ? (
        <VideoPlayer source={url} type={mime} />
      ) : (
        <S.Illustration src={getImageURL(illustration)} className={'kenburns-image illustration'} />
      )}
    </S.Container>
  )
}

Illustration.propTypes = {
  illustration: PropTypes.object,
}

export default Illustration
